// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IDesktopGetNotificationsRequest,
  TDesktopGetNotificationsModel,
  IMappers,
  TDesktopGetNotificationsResponse,
  IDesktopGetNotificationsResponse,
  IDesktopGetNotificationsResponseError,
} from './types';

export const defaultConfig: TDesktopGetNotificationsModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'notification-center',
  pathApi: '/v1/desktop/get-notifications/',
  requestType: 'json',
} as TDesktopGetNotificationsModel;

export function createDesktopGetNotificationsModel(
  parameters: IDesktopGetNotificationsRequest,
): TDesktopGetNotificationsModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IDesktopGetNotificationsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IDesktopGetNotificationsRequest;
}

export async function fetchDesktopGetNotifications<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IDesktopGetNotificationsOptions<TResponse200, TResponse400>): Promise<
  TDesktopGetNotificationsResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createDesktopGetNotificationsModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IDesktopGetNotificationsResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IDesktopGetNotificationsResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TDesktopGetNotificationsResponse;
}
